<template>
  <div id="about">
    <div id="about_home">
      <div class="header-nav about-nav">
        <a class="tab-item" :class="{active: i == $store.state.aboutTabI}" v-for="(v, i) in menu_list" :key="i" @click="tabHandle(v)">{{v.cnName}}</a>
      </div>
      <div class="router-wrap">
        <router-view />
      </div>
      
    </div>
  </div>
</template>

<script>

import {getBannersByColId} from '@/api/project'
import {imgError} from '@/assets/utility.js'

export default {
  data() {
    return {
      banner: {
        imgUrl: ''
      },
      menu_list: [
        {
          cnName: '基金会简介',
          url: ''
        },
        {
          cnName: '基金会章程',
          url: 'constitution'
        },
        {
          cnName: '理事会介绍',
          url: 'organization'
        },
        {
          cnName: '联系我们',
          url: 'contact'
        }
      ],
      colId: '',
    }
  },
  mounted() {
    this.$store.commit('setCurrentMenuI', 6)
    this.colId = this.$route.params.cid
    getBannersByColId(this.$route.params.cid).then(res => {
      if (res) {
        this.banner = res[0]
      }
    })
  },
  methods: {
    tabHandle(pData) {
      this.$router.push(pData.url||`/about/${this.colId}/`)
    },
    imgError(pUrl) {
      imgError(pUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
  .router-wrap {
    padding: 0 rem(75);
  }
  @media only screen and (min-width: 768px) {
    // #about_home {
    //   padding: 0 rem(225);
    // }
    #about_tab {
      display: none;
    }
  }
  @media only screen and (max-width: 768px) {
    // #about_home {
    //   padding: 0 .575rem;
    // }
    #about_tab {
      padding: .7rem 0;
      .tab-item {
        display: inline-block;
        width: 1.58rem;
        height: 0.6rem;
        font-size: 0.25rem;
        font-weight: 400;
        line-height: 0.6rem;
        text-align: center;
        background-color: #eaf4ec;
      }
      .tab-item.active {
        color: #F7F7F7;
        background-color: #016b45;
      }
    }
    .about-nav {
      font-size: 14px;
      // .tab-item {
      //   //margin-right: 16px!important;
      // }
      
    }
  }
</style>
